import { Component } from '@angular/core';
import { OrderService } from './services/order.service';
import { OnInit } from '@angular/core';
import {ProductService} from "./services/product.service";
import {Product} from "./model/Product";
import {Type} from "./model/Type";
import {TypeAndProductsToDisplay} from "./model/TypeAndProductsToDisplay";
import {Router} from '@angular/router';
import {Photo} from "./model/Photo";
import {PhotoService} from "./services/photo.service";
import {ModalComponent} from "./components/modal-component";
import {TypeService} from "./services/type.service";
import {Order} from "./model/Order";
import {BillElements} from "./model/BillElement";
import {ProductAndNumber} from "./model/ProductAndNumber";
import {MenuService} from "./services/menu.service";
import {Menu} from "./model/Menu";
import {forEach} from "@angular/router/src/utils/collection";
import {MenuOrdered} from "./model/MenuOrdered";
import {Client} from "./model/Client";
import {GeocodingService} from "./services/geocoding.service";
import {Address} from "./model/Address";
import {_switch} from "rxjs/operator/switch";
import {ClientService} from "./services/client.service";
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import {DateToOrder} from "./model/DateToOrder";
import {HourToOrder} from "./model/HourToOrder";
import {State} from "./model/State";
import {PaymentMode} from "./model/PaymentMode";
import {environment} from "../environments/environment";

@Component({
    selector: 'app-client-list-products',
    templateUrl: './client-products.component.html',
    /*styleUrls: ['./app.component.css'],*/
    providers: [ProductService, MenuService, GeocodingService, ClientService, OrderService]
})

export class ClientProductsComponent implements OnInit {
    ngOnInit(): void {
        //this.getOrder();
        this.getListTypes();
        this.getListProducts();
        this.getListeMenus();
        this.initOrder();

        this.display['address'] = false;
        this.display['products'] = true;

        this.client = new Client();
        this.client.address = new Address();

        this.labelOrderButton = "Je renseigne mon adresse";
        this.labelDateOrder = "Jour";
        this.labelHourOrder = "Heure";

        this._consctructAvailableDatesAndHours();
    }
    title = 'My Order App';

    constructor(private productService : ProductService,
                private typeService : TypeService,
                private menuService : MenuService,
                private geocodingService : GeocodingService,
                private clientService : ClientService,
                private orderService : OrderService,
                private toastyService:ToastyService,
                private toastyConfig: ToastyConfig,
                private router: Router) {
        this.toastyConfig.theme = 'bootstrap';
    }

    listProducts: Product[];
    listTypes: Type[];
    listMenus: Menu[];
    listTypeAndProductsToDisplay: TypeAndProductsToDisplay[] = [];
    order: Order;
    billElementsList: BillElements[];
    billElement: BillElements;
    client: Client;
    clientAddress: string;

    selectedMenu: Menu;
    currentMenuOrdered: MenuOrdered;

    display: boolean[] = [];
    active: any[] = [];

    mapLat = 43.6109200;
    mapLng = 3.8772300;
    mapZoom = 11;

    clientAddressCardToDisplay: boolean = false;
    clientListAddress: Address[];
    clientAddressNeedDetails: boolean = false;

    labelOrderButton: string;
    labelDateOrder: string;
    labelHourOrder: string;

    dateOpenedToOrder: DateToOrder[] = [];
    hourOpenedToOrder: HourToOrder[] = [];

    imageBaseUri: string = environment.imageBaseUri;

    paymentModeList: PaymentMode[] = [
        new PaymentMode(1, "Carte bancaire", "http://www.wareega.com//img/cms/Logos%20moyens%20de%20paiement/carte-bancaire.jpg"),
        new PaymentMode(2, "Ticket restaurant", "https://d397xw3titc834.cloudfront.net/images/thumb/5/39/539dc5051ed0baa384bd8f231c8e0777.png"),
        new PaymentMode(3, "Espèces", "http://www.reserveafricainesigean.fr/wp-content/uploads/2017/03/paper-bill-kaki.png"),
        new PaymentMode(4, "Chèque", "http://www.reserveafricainesigean.fr/wp-content/uploads/2017/03/writing-cheque-copie.png")
    ];

    // INIT METHOD
    initOrder(): void {
        this.order = new Order();
        this.billElementsList = [];
        this.billElement = new BillElements();
        this.billElement.productAndNumberList = [];
        this.billElement.normalPrice = 0;
        this.billElement.finalPrice = 0;
        this.billElement.options = [];
        this.billElement.menuOrderedList = [];

        this.billElementsList.push(this.billElement);
    }


    /*************        SERVICES CALL -- Start         *************/
    getListProducts(): void {
        this.listTypeAndProductsToDisplay = [];
        this.productService.getListProducts(true).then((listProducts) => {
            //console.error("taille dans le app.component = " + listProducts);
            this.listProducts = listProducts;
            for(let product of listProducts) {
                let currentType = product.type;
                if(this.listTypeAndProductsToDisplay.hasOwnProperty(currentType.order) ) {
                    this.listTypeAndProductsToDisplay[currentType.order].listProducts.push(product);
                } else {
                    let newObject: TypeAndProductsToDisplay = {type : currentType, listProducts: [product]};
                    this.listTypeAndProductsToDisplay[currentType.order] = newObject;
                }
            }
        }, (error) => {
            console.error(error);
        });

    }

    getListTypes(): void {
        this.typeService.getListTypes().then((listTypes) => {
            this.listTypes = listTypes;
        }, (error) => {
            console.error(error);
        });
    }

    getListeMenus(): void {
        this.menuService.getListMenus().then((listMenus) => {
            this.listMenus = listMenus;
        }, (error) => {
            console.error(error);
        });
    }

    getClient(email : string): void {
        this.clientService.getClient(email).then((client) => {
            if(client !== null) {
                this.client = client;
                this.order.client = client;
                this.clientAddress = this._constructAddressToDisplay();
                this.selectClientUniqueAddress(this.client.address);
            }
        }, (error) => {
            console.error(error);
        });
    }

    addClient() : void {
        this.clientService.addClient(this.client).then((client) => {
            if(client.id) {
                this.order.client = client;
                this.client = client;
                this.clientAddress = this._constructAddressToDisplay();

                //Post order
                this.postOrder();
            } else {
                this._addToast("error","Une erreur s'est produite. Pour être sûr de prendre en compte votre commande, merci de nous contacter par téléphone.");
                console.error("Problème lors de la création de la fiche client");
            }

        }, (error) => {
            this._addToast("error","Une erreur s'est produite. Pour être sûr de prendre en compte votre commande, merci de nous contacter par téléphone.");
            console.error(error);
        });
    }

    postOrder() : void {
        this.order.billElementsList = this.billElementsList;
        let totalPrice: number = 0;
        for(let billElement of this.billElementsList) {
            totalPrice += billElement.finalPrice;
        }
        this.order.totalPrice = totalPrice;
        this.order.deliveryAddress = this.client.address;
        let stateOrder: State = new State(1);
        this.order.state = stateOrder;

        //this.order.paymentMode = this.paymentModeList[0];
        this.orderService.postOrder(this.order).then((order) => {
            this.order.id = order.id;

            //if OK, propose stripe ic card payment, confirmation if others
            if(this.order.id) {
                console.log("identifiant de la commande = " + this.order.id);
                if(this.order.paymentMode.id == 1) {
                    console.log("moyen de paiement CB ==> openCheckout");
                    this.openCheckout();
                } else {
                    alert("commande prise en compte");
                }
            } else {console.log("pas d'id de commande");}
        }, (error) => {
            if(error.json().error.code == 409) {
                this._addToast("error", error.json().error.message);
            } else {
                this._addToast("error","Une erreur s'est produite. Pour être sûr de prendre en compte votre commande, merci de nous contacter par téléphone.");
            }

            //console.error("code erreur ==> " + error.status + " / message ==> " + JSON.stringify(error.json()) + " / error object ==> " + error);
        });
    }
    /*************        SERVICES CALL -- End         *************/


    /*************        BUTTONS ACTIONS -- Start         *************/

    //Add a product to the bill
    addProductToBill(product:Product): void {
        if(!this.billElement.productAndNumberList[product.id]) {
            this.billElement.productAndNumberList[product.id] = new ProductAndNumber();
            this.billElement.productAndNumberList[product.id].number = 0;
        }
        let nb = this.billElement.productAndNumberList[product.id].number;
        if(nb == null) nb = 0;
        else {
            nb++;

            this.billElement.normalPrice = this.billElement.normalPrice + product.type.price;
            this.billElement.finalPrice = this.billElement.finalPrice + product.type.price;
            //If options, we count that
            if(product.option != null) {
                this.billElement.finalPrice = this.billElement.finalPrice + product.option.price;
                this.billElement.options.push(product.option);
            }
        }

        //this.nbProductsToOrder[product.id] = nb;

        let productAndNumber = new ProductAndNumber();
        productAndNumber.product = product;
        productAndNumber.number = nb;
        this.billElement.productAndNumberList[product.id] = productAndNumber;
    }
    //Remove one product from the bill
    removeProductFromBill(product:Product): void {
        let nb = this.billElement.productAndNumberList[product.id].number;
        if(nb == null) nb = 0;
        else if(nb > 0) {
            nb--;
            this.billElement.normalPrice = this.billElement.normalPrice - product.type.price;
            this.billElement.finalPrice = this.billElement.finalPrice - product.type.price;
            //If options, we count that
            if(product.option != null) {
                this.billElement.finalPrice = this.billElement.finalPrice - product.option.price;
                let indexOfOption = this.billElement.options.indexOf(product.option);
                this.billElement.options.splice(indexOfOption, 1);
            }
        }

        //this.nbProductsToOrder[product.id] = nb;
        if(nb === 0) {
            //if none, delete the item in array
            this.billElement.productAndNumberList.splice(product.id, 1);
        } else {
            let productAndNumber = new ProductAndNumber();
            productAndNumber.product = product;
            productAndNumber.number = nb;
            this.billElement.productAndNumberList[product.id] = productAndNumber;
        }
    }
    // remove a list of products from the list (trash button)
    removeProductsFromBill(product: Product): void {
        this.billElement.normalPrice -= this.billElement.productAndNumberList[product.id].number * this.billElement.productAndNumberList[product.id].product.type.price;
        this.billElement.finalPrice -= this.billElement.productAndNumberList[product.id].number * this.billElement.productAndNumberList[product.id].product.type.price;
        if(this.billElement.productAndNumberList[product.id].product.option) {
            this.billElement.finalPrice -= this.billElement.productAndNumberList[product.id].product.option.price;
        }
        this.billElement.productAndNumberList.splice(product.id,1);
    }
    //remove a product from the menu
    removeProductForMenu(product: Product): void {
        if(this.currentMenuOrdered) {
            let index = this.currentMenuOrdered.productList.indexOf(product);
            this.currentMenuOrdered.productList.splice(index, 1);

        }
    }
    //add menu to bill
    addMenuToBill(modal: ModalComponent): void {
        if(this.isMenuCompleted()) {
            let menuOrdered: MenuOrdered = {...this.currentMenuOrdered};
            this.billElement.menuOrderedList.push(menuOrdered);
            this.billElement.finalPrice += menuOrdered.menu.price;
            this.billElement.normalPrice += menuOrdered.menu.price;
            for (let product of menuOrdered.productList) {
                if (product.option) {
                    this.billElement.finalPrice += product.option.price;
                }
            }
            this.currentMenuOrdered = null;

            modal.hide();
        }
    }
    //remove menu from bill
    removeMenuFromBill(position: number) : void {
        let menuOrdered = this.billElement.menuOrderedList[position];
        this.billElement.finalPrice -= menuOrdered.menu.price;
        this.billElement.normalPrice -= menuOrdered.menu.price;
        for(let product of menuOrdered.productList) {
            if(product.option) {
                this.billElement.finalPrice -= product.option.price;
            }
        }

        this.billElement.menuOrderedList.splice(position, 1);
    }

    //Open modal when click on a menu
    openModalMenu(menu: Menu): void {
        this.selectedMenu = menu;
    }

    /*************        UTILS METHODS -- Start         *************/
    //Find an item in array
    isTypeIdFoundInArray(idType: number, typesList: Type[]): boolean {
        let result = false;

        if(typesList !== null) {
            for(let type of typesList) {
                if(type.id === idType) {
                    result = true;
                }
            }
        }
        return result;
    }
    //is it possible to select another item in the menu
    canProductInMenuBeSelected(product: Product): boolean {
        let result = true;

        if(this.currentMenuOrdered) {
            for(let productAlreadyOrdered of this.currentMenuOrdered.productList) {
                if(productAlreadyOrdered.type.id === product.type.id) {
                    result = false;
                }
            }
        }

        return result;
    }
    //Add a product to the menu
    selectProductForMenu(product: Product, menu: Menu): void {
        if(!this.currentMenuOrdered) {
            this.currentMenuOrdered = new MenuOrdered();
            this.currentMenuOrdered.productList = [];
            this.currentMenuOrdered.number = 1;
            this.currentMenuOrdered.menu = menu;
        }
        this.currentMenuOrdered.productList.push(product);
    }


    isMenuCompleted(): boolean {
        let isOk: boolean = true;

        if(this.currentMenuOrdered && this.currentMenuOrdered.productList) {
            let expectedTypeList = this.currentMenuOrdered.menu.typesList;
            for(let expectedType of expectedTypeList) {
                //if the expectedType is not found in the product list, return false
                let typeFound: boolean = false;
                for(let product of this.currentMenuOrdered.productList) {
                    if(product.type.id === expectedType.id) {
                        typeFound = true;
                    }
                }
                if(!typeFound) isOk = false;
            }
        }

        return isOk;
    }

    //back button
    back(): void {

    }

    //Valid button
    validBill(): void {
        //if ordering food
        if(this.display['products']) {
            if(this.billElement &&
                (this.billElement.productAndNumberList && this.billElement.productAndNumberList.length > 0
                || this.billElement.menuOrderedList && this.billElement.menuOrderedList.length > 0)) {
                this.display['address'] = true;
                this.display['products'] = false;
                this.labelOrderButton = "Je commande";
            } else {
                this._addToast("error", "Votre panier est vide");
            }
        } else if(this.display['address']) {
            //if(this.client.address && this.client.address.longitude) {
                let okToPost = true;
                //Verify the datas
                //Email
                okToPost = this.isFieldValid(this.client.email, "email") && okToPost;
                //name + Firstname
                okToPost = this.isFieldValid(this.client.firstName, "firstName") && okToPost;
                okToPost = this.isFieldValid(this.client.lastName, "lastName") && okToPost;
                //Tel
                okToPost = this.isFieldValid(this.client.tel, "tel") && okToPost;
                //day / hour
                okToPost = (this.order.date != null) && (this.order.time != null) && okToPost;
                //Address
                okToPost = this.isFieldValid(this.client.address.town, 'town') && okToPost;
                okToPost = this.isFieldValid(this.clientAddress, 'address') && okToPost;
                okToPost = (this.client.address != null && this.client.address.longitude != null) && okToPost;
                //Payement Mqode
                okToPost = this.isFieldValid(null, 'paymentMode') && okToPost;
                //Delivery Date
                okToPost = this.isFieldValid(null, 'deliveryDate') && okToPost;

                //If new client, create client first, then post order in callback. Else, post order directly
                if(okToPost) {
                    if (!this.client.id) {
                        this.addClient();
                    } else {
                        this.postOrder();
                    }

                    //Send client to payment page
                    //this.router.navigate(['/app-client-payment'], { queryParams: { orderId: this.order.id } });

                } else {
                    this._addToast("error", "Merci de renseigner les champs en erreur");
                }

            /*} else {
                this._addToast("error", "Merci de renseigner votre adresse");
            }*/
        }

    }

    isFieldValid(field: string, type: string): boolean {
        let result: boolean = false;
        let pattern = "";
        this.active[type] = false;

        switch (type) {
            case 'email':
                pattern = "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$";
                result = this._checkFieldContent(pattern, field, "email", "L'email", false);
                break;
            case 'lastName':
                pattern = "^[A-Za-z0-9-éàèêù ']*$";
                result = this._checkFieldContent(pattern, field, "lastName", "Le prénom", false);
                break;
            case 'firstName':
                pattern = "^[A-Za-z0-9-éàèêù ']*$";
                result = this._checkFieldContent(pattern, field, "firstName", "Le nom", false);
                break;
            case 'address':
                pattern = "^[A-Za-z0-9-éàèêù, ']*$";
                result = this._checkFieldContent(pattern, field, "address", "L'adresse", false);
                this.geocodeAddress(this.clientAddress + ", " + this.client.address.town);
                break;
            case 'town':
                pattern = "^[A-Za-z0-9-éàèêù ']*$";
                result = this._checkFieldContent(pattern, field, "town", "La ville", false);
                if(this.client.address.name && this.client.address.town) {
                    let addressToVerify = this.client.address.name + ", ";
                    if(this.client.address.street) {
                        if(this.client.address.streetNumber) addressToVerify += this.client.address.streetNumber + " ";
                        addressToVerify += this.client.address.street + " ";
                    }
                    addressToVerify += this.client.address.town;
                    this.geocodeAddress(addressToVerify);
                }
                break;
            case 'enterprise':
                pattern = "^[A-Za-z0-9-éàèêù ']*$";
                result = this._checkFieldContent(pattern, field, "enterprise", "L'entreprise", false);
                if(this.client.address.name && this.client.address.town) {
                    let addressToVerify = this.client.address.name + ", ";
                    if(this.client.address.street) {
                        if(this.client.address.streetNumber) addressToVerify += this.client.address.streetNumber + " ";
                        addressToVerify += this.client.address.street + " ";
                    }
                    addressToVerify += this.client.address.town;
                    this.geocodeAddress(addressToVerify);
                }
                break;
            case 'tel':
                pattern = "^0[1-9]([-. ]?[0-9]{2}){4}$";
                result = this._checkFieldContent(pattern, field, "tel", "Le téléphone", false);
                break;
            case 'paymentMode':
                if(this.order.paymentMode == null) {
                    this.active['paymentMode_feedback'] = true;
                    this.active['paymentMode_feedback_msg'] = "Ce champ est obligatoire";
                    this.active['paymentMode_error'] = true;
                } else {
                    this.active['paymentMode_feedback'] = false;
                    this.active['paymentMode_feedback_msg'] = "";
                    this.active['paymentMode_error'] = false;
                    result = true;
                }
                break;
            case 'deliveryDate':
                if(this.order.time == null || this.order.date == null) {
                    this.active['date_feedback'] = true;
                    this.active['date_feedback_msg'] = "Ce champ est obligatoire";
                    this.active['date_error'] = true;
                } else {
                    this.active['date_feedback'] = false;
                    this.active['date_feedback_msg'] = "";
                    this.active['date_error'] = false;
                    result = true;
                }
                break;
        }
        //console.log("resultat dans la méthode de validation dispatch = " + result);
        return result;
    }



    geocodeAddress(address: string): void {
        this.geocodingService.getLocation(address).then((results) => {
            console.log("number => " + results.length);
            if(results.length == 0) {
                //No address found
                console.log("no result");
            } else if(results.length == 1) {
                //One address found - create address and display on map
                console.log("one result");

                this.selectClientUniqueAddress(this._constructAddressObject(results[0]));
            } else if(results.length > 1) {
                //More than one address - user have to choose...
                console.log("too much result");
                let addressList: Address[] = [];

                for(let result of results) {
                    addressList.push(this._constructAddressObject(result));
                }

                this.clientAddressCardToDisplay = true;
                this.clientListAddress = addressList;
            }
        }, (error) => {
            console.error(error);
        });
    }

    selectClientUniqueAddress(address: Address): void {
        if(this.client.address.name) address.name = this.client.address.name;
        this.client.address = address;

        this.clientAddress = this._constructAddressToDisplay();

        //update map
        this.mapLat = this.client.address.latitude;
        this.mapLng = this.client.address.longitude;
        this.mapZoom = 15;
        this.clientListAddress = null;
        //Is the result precision ok ?
        if(address.precision != "ROOFTOP") {
            //Need details...
            this.clientAddressCardToDisplay = true;
            this.clientAddressNeedDetails = true;
        } else {
            this.clientAddressCardToDisplay = false;
            this.clientAddressNeedDetails = false;
        }
    }

    selectDayToOrder(dateToOrder: DateToOrder) : void {
        this.order.date = dateToOrder.date;
        this.labelDateOrder = dateToOrder.dayOfWeek;
        console.log("nouvelle date : " + this.order.date);
    }

    selectHourToOrder(hourToOrder: HourToOrder): void {
        this.order.time = hourToOrder.hourToDisplay;
        this.labelHourOrder = hourToOrder.hourToDisplay;
        console.log("nouvelle heure : " + this.order.time);
    }

    onPaymentModeChange(paymentMode: PaymentMode) {
        this.order.paymentMode = paymentMode;
        console.log("nouveau moyen de paiement : " + this.order.paymentMode.id);
    }

    /****** STRIPE ******/

    openCheckout(): void {
        let handler = (<any>window).StripeCheckout.configure({
            key: 'pk_test_oi0sKPJYLGjdvOXOM8tE8cMa',
            locale: 'auto',
            token: function (token: any) {
                // You can access the token ID with `token.id`.
                // Get the token ID to your server-side code for use.
            }
        }
    );

    handler.open({
        email: "test@test.fr",
        name: 'Instant Bocal',
        description: 'Votre commande de bocaux',
        panelLabel: 'Payer {{amount}} TTC',
        locale: 'fr',
        zipCode: true,
        image:'https://instant-bocal.com/wp-content/uploads/2017/03/Instant-Bocal-TOUT-PETIT-POUR-SITE.png',
        amount: this.order.totalPrice * 100,
        currency:'EUR',
        allowRememberMe: false
    });

    }

    /****** STRIPE END******/



    getAddressJson() {
        return JSON.stringify(this.clientListAddress);
    }
    getClientJson() {
        return JSON.stringify(this.client);
    }

    private _stringFoundInArray(array: string[], toFind: string) {
        let found: boolean = false;
        for(let item of array) {
            if(item === toFind) {
                found = true;
            }
        }

        return found;
    }

    private _constructAddressObject(googleRes):Address {
        let address:Address = new Address();
        for(let component of googleRes.address_components) {
            if(this._stringFoundInArray(component.types, "street_number")) {
                address.streetNumber = component.long_name;
            } else if(this._stringFoundInArray(component.types, "route")) {
                address.street = component.long_name;
            } else if(this._stringFoundInArray(component.types, "locality")) {
                address.town = component.long_name;
            } else if(this._stringFoundInArray(component.types, "postal_code")) {
                address.postalCode = component.long_name;
            }
        }

        address.formattedAddress = googleRes.formatted_address.replace(/, France/gi, "");

        address.latitude = googleRes.geometry.location.lat;
        address.longitude = googleRes.geometry.location.lng;
        address.precision = googleRes.geometry.location_type;

        return address;
    }

    private _addToast(type: string, message: string) {
        // Just add default Toast with title only
        if(type === "error") {
            this.toastyService.error(message);
        } else {
            this.toastyService.default(message);
        }

        // Or create the instance of ToastOptions
        /*var toastOptions:ToastOptions = {
            title: title,
            msg: message,
            showClose: true,
            timeout: 5000,
            theme: 'default',
            onAdd: (toast:ToastData) => {
                console.log('Toast ' + toast.id + ' has been added!');
            },
            onRemove: function(toast:ToastData) {
                console.log('Toast ' + toast.id + ' has been removed!');
            }
        };
        // Add see all possible types in one shot
        this.toastyService.info(toastOptions);
        this.toastyService.success(toastOptions);
        this.toastyService.wait(toastOptions);
        this.toastyService.error(toastOptions);
        this.toastyService.warning(toastOptions);*/
    }

    private _constructAddressToDisplay() : string {
        let address = "";
        if(this.client.address.streetNumber) {
            address = this.client.address.streetNumber + " ";
        }
        address += this.client.address.street;

        return address;
    }

    private _consctructAvailableDatesAndHours(): void {
        //DATES
        let today = new Date();
        let numberOfDaysToAdd = 7;

        for(let toAdd = 0; toAdd <= numberOfDaysToAdd; toAdd++) {
            if(toAdd != 0 || (toAdd == 0 && today.getHours() > 13))
                today.setDate(today.getDate() + 1);

            let day: string = "";
            let month: string = "";
            let y = today.getFullYear();
            let dayOfWeek = today.getDay();
            switch(dayOfWeek) {
                case 0: {day = "Dimanche"; break;}
                case 1: {day = "Lundi"; break;}
                case 2: {day = "Mardi"; break;}
                case 3: {day = "Mercredi"; break;}
                case 4: {day = "Jeudi"; break;}
                case 5: {day = "Vendredi"; break;}
                case 6: {day = "Samedi"; break;}
            }
            switch(today.getMonth() + 1) {
                case 1: {month = "Janvier"; break;}
                case 2: {month = "Février"; break;}
                case 3: {month = "Mars"; break;}
                case 4: {month = "Avril"; break;}
                case 5: {month = "Mai"; break;}
                case 6: {month = "Juin"; break;}
                case 7: {month = "Juillet"; break;}
                case 8: {month = "Août"; break;}
                case 9: {month = "Septembre"; break;}
                case 10: {month = "Octobre"; break;}
                case 11: {month = "Novembre"; break;}
                case 12: {month = "Décembre"; break;}
            }
            let someFormattedDate = day + " " + today.getDate() + " " + month;
            if(toAdd === 0) someFormattedDate = "Aujourd'hui";
            //Add date if not saturday or sunday
            if(dayOfWeek !== 0 && dayOfWeek !== 6) {
                let dateToOrder: DateToOrder = new DateToOrder();
                dateToOrder.dayOfWeek = day + " " + today.getDate();
                dateToOrder.dateToDisplay = someFormattedDate;
                dateToOrder.date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
                //console.log("Ajout d'une nouvelle date : " + dateToOrder.dateToDisplay + " / " + dateToOrder.date);
                this.dateOpenedToOrder[toAdd] = dateToOrder;
            }
        }

        //HOURS
        this.hourOpenedToOrder.push(new HourToOrder(11, 30, "11:30"));
        this.hourOpenedToOrder.push(new HourToOrder(12, 0, "12:00"));
        this.hourOpenedToOrder.push(new HourToOrder(12, 30, "12:30"));
        this.hourOpenedToOrder.push(new HourToOrder(13, 0, "13:00"));
        this.hourOpenedToOrder.push(new HourToOrder(13, 30, "13:30"));
        this.hourOpenedToOrder.push(new HourToOrder(14, 0, "14:00"));
    }

    /**
     *
     * @param pattern
     * @param field
     * @param name
     * @param label
     * @param nullable
     * @returns {null}
     * @private
     */
    private _checkFieldContent(pattern:string, field:string, name:string, label:string, nullable:boolean): boolean {
        let result = false;

        console.log("analyse de la valeur du champ " + name + " ==> " + field);

        if(!nullable && (field == null || field == "")) {
            result = false;
            this.active[name + '_feedback'] = true;
            this.active[name + '_feedback_msg'] = label + " est obligatoire";
            this.active[name + '_error'] = true;
            console.error("le champ " + name + " est vide - " + field);
        } else {

            let regex = new RegExp(pattern);
            result = regex.test(field);

            if (!result) {
                this.active[name + '_feedback'] = true;
                this.active[name + '_feedback_msg'] = label + " est incorrect";
                this.active[name + '_error'] = true;
            } else {
                this.active[name + '_feedback'] = true;
                this.active[name + '_feedback_msg'] = null;
                this.active[name + '_error'] = false;
            }
        }

        console.log("resultat " + name + " ==> " + result);

        return result;
    }
}



// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/client-products.component.ts